import { Component, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { SnotifyService } from 'ng-snotify';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { Faq } from 'src/app/shared/models/faqs.model';
import { RowAction } from 'src/app/shared/base-reporting/models/row-actions.interface';
import { FilterItem } from 'src/app/shared/base-reporting/models/filter-item.interface';
import { FilterCallback } from 'src/app/shared/base-reporting/models/filter-callback.interface';
import { RowActionCallback } from 'src/app/shared/base-reporting/models/row-action-callback.interface';
import { FaqsService } from '../faqs.service';

@Component({
  selector: 'app-faqs-list',
  templateUrl: './faqs-list.component.html',
  styleUrls: ['./faqs-list.component.css']
})
export class FaqsListComponent implements OnInit {
  faq = new Faq();
  tableColumns = ['question', 'answer', 'groupId', 'createdAt', 'updatedAt'];
  rowActions: Array<RowAction> = [
    {
      type: 'icon',
      slug: 'editFaq',
      class: 'btn',
      iconClasses: 'fa fa-edit'
    },
    {
      type: 'icon',
      slug: 'deleteFaq',
      class: 'btn',
      iconClasses: 'fa fa-trash'
    }
  ];
  reportFilter: Array<FilterItem> = [
    {
      fieldName: 'question',
      fieldDisplayName: 'Question ',
      fieldType: 'text'
    },
    {
      fieldName: 'answer',
      fieldDisplayName: 'Answer ',
      fieldType: 'text'
    },
    {
      fieldName: 'createdAt',
      fieldDisplayName: 'created At ',
      fieldType: 'daterange'
    },
    // {
    //   fieldName: 'expired',
    //   fieldDisplayName: 'Expired ',
    //   fieldType: 'select',
    //   multiple: false,
    //   hasSelectAll: false,
    //   defaultValue: null,
    //   options: [
    //     { value: 'true', display: 'True' },
    //     { value: 'false', display: 'False' },
    //     { value: '', display: 'All'}

    //   ]
    // }
  ];
  private Data = [] as Array<TableViewItem>;
  currentFilterObject = {} as FilterModel;
  constructor(
    private faqsApi: FaqsService,
    private notifier: SnotifyService,
    private router: Router,
    private datePipe: DatePipe
  ) {}

  get data(): Array<TableViewItem> {
    return this.Data.filter(row => {
      if (
        this.currentFilterObject.createdAt &&
        this.currentFilterObject.createdAt.startDate &&
        this.currentFilterObject.createdAt.endDate
      ) {
        return moment(row.createdAt).isBetween(
          // @ts-ignore
          this.currentFilterObject.expiresAt.startDate._i,
          // @ts-ignore
          this.currentFilterObject.expiresAt.endDate._i
        );
      } else {
        return true;
      }
    })
    .filter(row => {
      if (this.currentFilterObject.question) {
        return row.question.includes(this.currentFilterObject.question);
      }
      return true;
    }) .filter(row => {
      if (this.currentFilterObject.answer) {
        return row.answer.includes(this.currentFilterObject.answer);
      }
      return true;
    });
  }
  set data(v: Array<TableViewItem>) {
    this.Data = v;
  }

  ngOnInit() {
    this.fetchAllFaqs();
  }

  onFilter(event: FilterCallback) {
    this.currentFilterObject = event.filter;
  }

  private fetchAllFaqs() {
    this.faqsApi.getFaqs().subscribe(response => {
      // console.log(response)
      this.data = response.data.faqs.map(r => {
        return {
          id: r.id,
          question: r.question,
          answer: r.answer,
          groupId: r.groupId,
          createdAt: r.createdAt,
          updatedAt: r.updatedAt
        } as TableViewItem;
      });
    });
  }
  rowActionCB(event: RowActionCallback) {
    switch (event.action) {
      case 'editFaq':
        this.faq = event.on;
        this.router.navigateByUrl('/settings/faqs/edit/' + this.faq.id);
        break;
      case 'deleteFaq':
        this.faq = event.on;
        this.deleteGroup(this.faq);
        break;
      default:
        console.error('this is a mistake!');
    }
  }
  fetchTable(event) {
    if (event[`flag`] === true) {
      this.fetchAllFaqs();
    }
  }
  deleteGroup(row) {
    this.faqsApi.deleteGroupFaq(row.id).subscribe(Response => {
      // console.log(Response);
      this.notifier.success('The Chosen Faq is Deleted SuccessFully ');
      this.fetchAllFaqs();
    });
  }
}

interface TableViewItem {
  question?: string;
  answer?: string;
  groupId?: number;
  createdAt?: string;
  updatedAt?: string;
}

interface FilterModel {
  question?: string;
  answer?: string;
  createdAt?: DateRangeModel;
}

interface DateRangeModel {
  startDate?: moment.Moment;
  endDate?: moment.Moment;
}
